"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.success = success;
exports.failure = failure;
exports.runWithAlert = runWithAlert;
exports.alertOnError = alertOnError;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _Alert = _interopRequireDefault(require("@civicplus/preamble/lib/Utilities/Alert"));

// TODO: This component should be deprecated in favor of enqueueSnackbar
function success(message) {
  _Alert["default"].showSuccess(message);
}

function failure(message) {
  _Alert["default"].showError(message);
}

function runWithAlert(_x, _x2) {
  return _runWithAlert.apply(this, arguments);
}

function _runWithAlert() {
  _runWithAlert = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(message, func) {
    var resp;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return func();

          case 3:
            _context.next = 16;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error(_context.t0);
            _context.t1 = _context.t0.json;

            if (!_context.t1) {
              _context.next = 13;
              break;
            }

            _context.next = 12;
            return _context.t0.json();

          case 12:
            _context.t1 = _context.sent;

          case 13:
            resp = _context.t1;
            extractErrorMessageAndNotify("Failed to run operation", resp || _context.t0);
            return _context.abrupt("return", false);

          case 16:
            success(message);
            return _context.abrupt("return", true);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _runWithAlert.apply(this, arguments);
}

function alertOnError(_x3, _x4) {
  return _alertOnError.apply(this, arguments);
}

function _alertOnError() {
  _alertOnError = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(message, func) {
    var includeExceptionMessage,
        resp,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            includeExceptionMessage = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
            _context2.prev = 1;
            _context2.next = 4;
            return func();

          case 4:
            _context2.next = 17;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](1);
            _context2.t1 = _context2.t0.json;

            if (!_context2.t1) {
              _context2.next = 13;
              break;
            }

            _context2.next = 12;
            return _context2.t0.json();

          case 12:
            _context2.t1 = _context2.sent;

          case 13:
            resp = _context2.t1;
            // eslint-disable-next-line no-console
            console.error("requesterror", _context2.t0, resp);
            extractErrorMessageAndNotify(message, resp || _context2.t0);
            return _context2.abrupt("return", false);

          case 17:
            return _context2.abrupt("return", true);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 6]]);
  }));
  return _alertOnError.apply(this, arguments);
}

function extractErrorMessageAndNotify(message, exception) {
  if (exception.status === 404) {
    var _ref, _exception$message;

    failure("".concat(message, " : ").concat((_ref = (_exception$message = exception.message) !== null && _exception$message !== void 0 ? _exception$message : exception.title) !== null && _ref !== void 0 ? _ref : "Not found"));
  } else {
    //default error reporting
    if (exception.details) {
      var _exception$message2;

      failure("".concat(message, " : ").concat((_exception$message2 = exception.message) !== null && _exception$message2 !== void 0 ? _exception$message2 : "Something went wrong", " - ").concat(exception.details.join("; ")));
    } else {
      var _exception$message3;

      failure("".concat(message, " : ").concat((_exception$message3 = exception.message) !== null && _exception$message3 !== void 0 ? _exception$message3 : "Something went wrong"));
    }
  }
}